import { OrderCommonStatus, OrderMovieStatus } from '@/view-models/order'

const checkOrderIsOld = dateTime => {
  const bookingTime = new Date(dateTime).getTime()
  const yesterday = new Date().getTime() - 86400000 // 86400000: 24H timestamp
  return bookingTime < yesterday
}

const getOrderStatus = userOrder => {
  switch (userOrder.status) {
    case 2: {
      const isYesterdayOrder = checkOrderIsOld(userOrder.booking_time)
      const hasCert = userOrder.hasOwnProperty('cert') && userOrder.cert_path

      if ((userOrder.review_rating || userOrder.reviewed) > 0) {
        return 'commented'
      } else if (!!userOrder.used_time || userOrder.has_cert || hasCert || isYesterdayOrder) {
        return userOrder.has_cert ? 'cert' : 'redeem'
      } else {
        return 'booking-success'
      }
    }
    case 6:
    case 7:
    case 9:
    case 10:
      return 'cancel'
  }

  return ''
}

const getDeliveryOrderStatus = userOrder => {
  const bookingDateTime = userOrder.booking_time || userOrder.estimated_delivery_time
  const isYesterdayOrder = checkOrderIsOld(bookingDateTime)
  const reviewRating = userOrder.review_rating || userOrder.reviewed

  if (userOrder.status === 6) {
    return 'cancel'
  } else {
    switch (userOrder.delivery.status) {
      case 0:
      case 1:
      case 2:
        if (isYesterdayOrder) {
          return reviewRating > 0 ? 'commented' : 'redeem'
        }
        return 'booking-success'
      case 3:
        if (reviewRating > 0) {
          return 'commented'
        }
        return 'redeem'
      case 4:
        return 'cancel'
      default:
        return isYesterdayOrder ? 'redeem' : ''
    }
  }
}

const getGiftStatus = giftStatus => {
  switch (giftStatus) {
    case 0:
      return 'unreceived'
    case 1:
      return 'received'
    case 2:
      return 'booking'
    case 3:
      return 'cancel'
    case 4:
      return 'expired'
    default:
      return ''
  }
}

function getMovieOrderStatus(movieStatus) {
  switch (movieStatus) {
    case OrderMovieStatus.Redeem:
      return OrderCommonStatus.Redeem
    case OrderMovieStatus.Cancel:
      return OrderCommonStatus.Cancel
    case OrderMovieStatus.Commented:
      return OrderCommonStatus.Commented
    case OrderMovieStatus.BookingSuccess:
      return OrderCommonStatus.BookingSuccess
    default:
      return movieStatus
  }
}

export { getOrderStatus, getDeliveryOrderStatus, getGiftStatus, getMovieOrderStatus }
